import React from 'react'

import * as def from './define'

/** 登録内容の確認テーブルを作成 */
export default function makeInfoTable(info) {
  let infoRows = []
  infoRows.push(
    <tr key='cont-1'>
      <td colSpan='3' style={{ textAlign: 'left', backgroundColor: 'lightgray', padding: '10px' }}>契約情報</td>
    </tr>)
  infoRows.push(
    <tr key='cont-2'>
      <td style={{ textAlign: 'right' }}>契約ID</td>
      <td></td>
      <td style={{ textAlign: 'left' }}>{info.contractId}</td>
    </tr>)

  if (info.mode === def.MODE.CREATE_TENANT) {
    // 新しくテナントを作成する場合のみ表示
    infoRows.push(
      <tr key='comp-1'>
        <td colSpan='3' style={{ textAlign: 'left', backgroundColor: 'lightgray', padding: '10px' }}>ひとつめの会社情報</td>
      </tr>)
    infoRows.push(
      <tr key='comp-2'>
        <td style={{ textAlign: 'right' }}>会社ID</td>
        <td></td>
        <td style={{ textAlign: 'left' }}>{info.companyId}</td>
      </tr>)
    infoRows.push(
      <tr key='comp-3'>
        <td colSpan='3' style={{ borderBottom: 'solid 1px' }}></td>
      </tr>)
    infoRows.push(
      <tr key='comp-4'>
        <td style={{ textAlign: 'right' }}>会社名称</td>
        <td></td>
        <td style={{ textAlign: 'left' }}>{info.companyName}</td>
      </tr>)
    infoRows.push(
      <tr key='comp-5'>
        <td colSpan='3' style={{ borderBottom: 'solid 1px' }}></td>
      </tr>)
    infoRows.push(
      <tr key='comp-6'>
        <td style={{ textAlign: 'right' }}>社員パスワードの有効期間</td>
        <td></td>
        <td style={{ textAlign: 'left' }}>{(info.pwEffectiveDays > 0) ? info.pwEffectiveDays : '無期限'}</td>
      </tr>)

    if (info.serviceType === def.SERVICE_TYPE.STAMP || info.serviceType === def.SERVICE_TYPE.ATTENDANCE) {
      // 〈打刻〉の場合のみ表示
      infoRows.push(
        <tr key='comp-7'>
          <td colSpan='3' style={{ borderBottom: 'solid 1px' }}></td>
        </tr>)
      infoRows.push(
        <tr key='comp-8'>
          <td style={{ textAlign: 'right' }}>画像添付</td>
          <td></td>
          <td style={{ textAlign: 'left' }}>{info.needPicture ? '有' : '無'}</td>
        </tr>)
      infoRows.push(
        <tr key='comp-9'>
          <td colSpan='3' style={{ borderBottom: 'solid 1px' }}></td>
        </tr>)
      infoRows.push(
        <tr key='comp-10'>
          <td style={{ textAlign: 'right' }}>位置情報添付</td>
          <td></td>
          <td style={{ textAlign: 'left' }}>{info.needLocation ? '有' : '無'}</td>
        </tr>)
    }
  }

  infoRows.push(
    <tr key='admin-1'>
      <td colSpan='3' style={{ textAlign: 'left', backgroundColor: 'lightgray', padding: '10px' }}>管理者情報</td>
    </tr>)
  infoRows.push(
    <tr key='admin-2'>
      <td style={{ textAlign: 'right' }}>管理者ID</td>
      <td></td>
      <td style={{ textAlign: 'left' }}>{info.adminId}</td>
    </tr>)
  infoRows.push(
    <tr key='admin-3'>
      <td colSpan='3' style={{ borderBottom: 'solid 1px' }}></td>
    </tr>)
  infoRows.push(
    <tr key='admin-4'>
      <td style={{ textAlign: 'right' }}>管理者名</td>
      <td></td>
      <td style={{ textAlign: 'left' }}>{info.adminName}</td>
    </tr>)
  infoRows.push(
    <tr key='admin-5'>
      <td colSpan='3' style={{ borderBottom: 'solid 1px' }}></td>
    </tr>)
  infoRows.push(
    <tr key='admin-6'>
      <td style={{ textAlign: 'right' }}>メールアドレス</td>
      <td></td>
      <td style={{ textAlign: 'left' }}>{info.adminMailAddress}</td>
    </tr>)

  if (info.mode === def.MODE.CREATE_TENANT) {
    // 新しくテナントを作成する場合のみ表示
    infoRows.push(
      <tr key='pass'>
        <td colSpan='3' style={{ fontSize: 'small', textAlign: 'left' }}>※ セキュリティの観点から、パスワードは表示していません。</td>
      </tr>)
  }

  return <table style={{ width: '100%' }}>
    <thead>
      <tr>
        <th style={{ width: '280px' }}></th>
        <th style={{ width: '20px' }}></th>
        <th style={{ width: '*' }}></th>
      </tr>
    </thead>
    <tbody>
      {infoRows}
    </tbody>
  </table>
}


// WEBPACK FOOTER //
// ./src/makeInfoTable.js